// extracted by mini-css-extract-plugin
module.exports = {"textArea":"DisputeDetails_textArea__F5mbt"};